import * as TypeGraphQL from "type-graphql";
export var PortfolioGreeksHistoryScalarFieldEnum;
(function (PortfolioGreeksHistoryScalarFieldEnum) {
    PortfolioGreeksHistoryScalarFieldEnum["id"] = "id";
    PortfolioGreeksHistoryScalarFieldEnum["accountId"] = "accountId";
    PortfolioGreeksHistoryScalarFieldEnum["timestamp"] = "timestamp";
    PortfolioGreeksHistoryScalarFieldEnum["contractId"] = "contractId";
    PortfolioGreeksHistoryScalarFieldEnum["symbol"] = "symbol";
    PortfolioGreeksHistoryScalarFieldEnum["underlying"] = "underlying";
    PortfolioGreeksHistoryScalarFieldEnum["delta"] = "delta";
    PortfolioGreeksHistoryScalarFieldEnum["gamma"] = "gamma";
    PortfolioGreeksHistoryScalarFieldEnum["theta"] = "theta";
    PortfolioGreeksHistoryScalarFieldEnum["vega"] = "vega";
    PortfolioGreeksHistoryScalarFieldEnum["rho"] = "rho";
    PortfolioGreeksHistoryScalarFieldEnum["totalDelta"] = "totalDelta";
    PortfolioGreeksHistoryScalarFieldEnum["totalGamma"] = "totalGamma";
    PortfolioGreeksHistoryScalarFieldEnum["totalTheta"] = "totalTheta";
    PortfolioGreeksHistoryScalarFieldEnum["totalVega"] = "totalVega";
    PortfolioGreeksHistoryScalarFieldEnum["totalRho"] = "totalRho";
    PortfolioGreeksHistoryScalarFieldEnum["positionCount"] = "positionCount";
    PortfolioGreeksHistoryScalarFieldEnum["underlyingSymbols"] = "underlyingSymbols";
    PortfolioGreeksHistoryScalarFieldEnum["expirationDates"] = "expirationDates";
    PortfolioGreeksHistoryScalarFieldEnum["marketHours"] = "marketHours";
    PortfolioGreeksHistoryScalarFieldEnum["vix"] = "vix";
    PortfolioGreeksHistoryScalarFieldEnum["spyPrice"] = "spyPrice";
    PortfolioGreeksHistoryScalarFieldEnum["source"] = "source";
    PortfolioGreeksHistoryScalarFieldEnum["createdAt"] = "createdAt";
})(PortfolioGreeksHistoryScalarFieldEnum || (PortfolioGreeksHistoryScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(PortfolioGreeksHistoryScalarFieldEnum, {
    name: "PortfolioGreeksHistoryScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=PortfolioGreeksHistoryScalarFieldEnum.js.map